import { render, staticRenderFns } from "./RefundDeliver.vue?vue&type=template&id=608eaaa4&scoped=true&"
import script from "./RefundDeliver.vue?vue&type=script&lang=js&"
export * from "./RefundDeliver.vue?vue&type=script&lang=js&"
import style0 from "./RefundDeliver.vue?vue&type=style&index=0&id=608eaaa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608eaaa4",
  null
  
)

export default component.exports